import * as React from 'react'

const stopPropagation = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
  event.stopPropagation()

const StopClickEventPropagation: React.FC<{
  children?: React.ReactNode
  style?: React.HTMLAttributes<HTMLSpanElement>['style']
  className?: string
}> = ({ children, style, className }) => {
  const styleWithResetCursor = React.useMemo(
    () => ({ ...style, cursor: 'initial' }),
    [style],
  )
  return (
    <span
      style={styleWithResetCursor}
      className={className}
      onClick={stopPropagation}
    >
      {children}
    </span>
  )
}

export default StopClickEventPropagation
